export const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export const capitalize = (text) => text[0].toUpperCase() + text.slice(1);
